<template>
    <section class="cardapio-digital-detalhe-produto">
        <section class="cardapio-digital-detalhe-produto-section" v-if="!exibeDetalheImagem">
            <div class="cardapio-digital-detalhe-produto-section-imagem-container">
                <i class="cardapio-digital-detalhe-produto-section-btn-voltar 
                        is-clickable 
                        fas fa-arrow-left"
                    @click="voltarListaProduto(produto.grupo)">
                </i>     
                <img class="cardapio-digital-detalhe-produto-section-imagem"
                    :src="produto.img" 
                    :alt="produto.titulo" 
                    :title="produto.titulo"
                    @click="abrirImagem"
                    onerror="this.onerror=null; this.src='./img/semimagem.png'"
                >
                <i class="cardapio-digital-detalhe-produto-section-btn-zoom 
                        is-clickable 
                        fas fa-solid fa-magnifying-glass-plus"
                    @click="abrirImagem">
                </i>
            </div>
            <div class="cardapio-digital-detalhe-produto-section-info">
                <h4 class="title is-3 is-bold">{{produto.titulo}}</h4>
                <p class="cardapio-digital-detalhe-produto-section-lista-card-info-descricao">{{produto.descricao}}</p>
                <p class="cardapio-digital-detalhe-produto-section-lista-card-info-preco" v-if="!ehProdutoPizza">{{valorTotalProduto | currency}}</p>
                <p class="cardapio-digital-detalhe-produto-section-lista-card-info-preco" v-if="ehProdutoPizza && !valorTotalPizza">{{valorMinimoPizza | currency}} - {{valorMaximoPizza | currency}}</p>
                <p class="cardapio-digital-detalhe-produto-section-lista-card-info-preco" v-if="ehProdutoPizza && valorTotalPizza">{{valorTotalPizza | currency}}</p>
                <div class="cardapio-digital-detalhe-produto-section-informacoes" v-if="caracteristicas.length || exibeAlertaProduto">
                  <h4 class="title is-4 is-bold">Informações importantes</h4>
                  <div class="mb-3">
                    
                    <div class="cardapio-digital-detalhe-produto-section-informacoes-alerta has-background-danger-light has-text-danger-dark is-5" v-if="exibeAlertaProduto" v-html="textoInfoCaracteristica"></div>
                  </div>
                  <div class="cardapio-digital-detalhe-produto-section-informacoes-lista">
                    <div class="cardapio-digital-detalhe-produto-section-informacoes-lista-card-informacoes" 
                      v-for="caracteristica in caracteristicas" :key="caracteristica.id" 
                    >
                      <img class="cardapio-digital-detalhe-produto-section-informacoes-lista-card-img"
                        :src="caracteristica.img" 
                        :alt="caracteristica.descricao" 
                        :title="caracteristica.descricao"
                        onerror="this.onerror=null; this.src='./img/semimagem.png'"
                      >
                      <p class="cardapio-digital-detalhe-produto-section-informacoes-lista-card-descricao">{{caracteristica.descricao}}</p>
                    </div>
                  </div>
                </div>
                <div class="cardapio-digital-detalhe-produto-section-adicionais" v-if="adicionais.length && !ehProdutoPizza">
                    <h4 class="title is-3 is-bold">Adicionais</h4>
                    <div class="cardapio-digital-detalhe-produto-section-pizza-lista">
                        <div class="cardapio-digital-detalhe-produto-section-pizza-lista-card card-adicional is-clickable" 
                            v-for="adicional in adicionais" :key="adicional.id">
                            <img class="cardapio-digital-detalhe-produto-section-pizza-lista-card-img"
                                :src="adicional.img" 
                                :alt="adicional.descricao" 
                                :title="adicional.descricao"
                                onerror="this.onerror=null; this.src='./img/semimagem.png'"
                            >
                            <p class="cardapio-digital-detalhe-produto-section-pizza-lista-card-info-descricao">{{adicional.descricao}}</p>
                            <p class="cardapio-digital-detalhe-produto-section-pizza-lista-card-info-preco">{{adicional.preco | currency}}</p>
                            <div class="cardapio-digital-detalhe-produto-section-pizza-lista-card-info-botoes">
                                <button class="botao-adicionar has-text-success is-clickable"
                                    @click="adicional.quantidade++, adicionaQtdAdicional(adicional)"
                                >
                                    <i class="fas fa-plus"></i>
                                </button>
                                <input class="input-quantidade-adicional" disabled type="text" v-model="adicional.quantidade">
                                <button class="botao-diminuir has-text-danger is-clickable"
                                    :disabled="adicional.quantidade==0"
                                    @click="adicional.quantidade--, removeQtdAdicional(adicional)"
                                >
                                    <i class="fas fa-minus"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <section v-if="ehProdutoPizza">
                    <div class="cardapio-digital-detalhe-produto-section-pizza" v-if="produto.tamanhos.length">
                        <h4 class="title is-4 is-bold">Selecione o tamanho</h4>
                        <div class="cardapio-digital-detalhe-produto-section-pizza-lista">
                            <div class="cardapio-digital-detalhe-produto-section-pizza-lista-card is-clickable" 
                                v-for="tamanho in produto.tamanhos" :key="tamanho.id" 
                                @click="buscarInfoPorTamanho(tamanho)"
                                :class="{cardSelecionado: tamanho === tamanhoSelecionado}"
                            >
                                <p class="cardapio-digital-detalhe-produto-section-pizza-lista-card-info-descricao">{{tamanho.descricao}}</p>
                                <p class="cardapio-digital-detalhe-produto-section-pizza-lista-card-info-preco">{{tamanho.preco | currency}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="cardapio-digital-detalhe-produto-section-pizza" v-if="massas.length">
                        <h4 class="title is-4 is-bold">Selecione o tipo da massa</h4>
                        <div class="cardapio-digital-detalhe-produto-section-pizza-lista">
                            <div class="cardapio-digital-detalhe-produto-section-pizza-lista-card is-clickable" 
                                v-for="massa in massas" :key="massa.id" 
                                @click="buscarInfoPorMassa(massa)"
                                :class="{cardSelecionado: massa === massaSelecionada}"
                            >
                                <p class="cardapio-digital-detalhe-produto-section-pizza-lista-card-info-descricao">{{massa.descricao}}</p>
                                <p class="cardapio-digital-detalhe-produto-section-pizza-lista-card-info-preco">{{massa.preco | currency}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="cardapio-digital-detalhe-produto-section-pizza" v-if="bordas.length">
                        <h4 class="title is-4 is-bold">Selecione a borda</h4>
                        <div class="cardapio-digital-detalhe-produto-section-pizza-lista">
                            <div class="cardapio-digital-detalhe-produto-section-pizza-lista-card is-clickable" 
                                v-for="borda in bordas" :key="borda.id" 
                                @click="buscarInfoPorBorda(borda)"
                                :class="{cardSelecionado: borda === bordaSelecionada}"
                            >
                                <p class="cardapio-digital-detalhe-produto-section-pizza-lista-card-info-descricao">{{borda.descricao}}</p>
                                <p class="cardapio-digital-detalhe-produto-section-pizza-lista-card-info-preco">{{borda.preco | currency}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="cardapio-digital-detalhe-produto-section-pizza" v-if="exibeAdicionalPizza && adicionais.length">
                        <h4 class="title is-4 is-bold">Deseja incluir algum adicional?</h4>
                        <div class="cardapio-digital-detalhe-produto-section-pizza-lista">
                            <div class="cardapio-digital-detalhe-produto-section-pizza-lista-card card-adicional is-clickable" 
                                v-for="adicional in adicionais" :key="adicional.id">
                                <img class="cardapio-digital-detalhe-produto-section-pizza-lista-card-img"
                                    :src="adicional.img" 
                                    :alt="adicional.descricao" 
                                    :title="adicional.descricao"
                                    onerror="this.onerror=null; this.src='./img/semimagem.png'"
                                >
                                <p class="cardapio-digital-detalhe-produto-section-pizza-lista-card-info-descricao">{{adicional.descricao}}</p>
                                <p class="cardapio-digital-detalhe-produto-section-pizza-lista-card-info-preco">{{adicional.preco | currency}}</p>
                                <div class="cardapio-digital-detalhe-produto-section-pizza-lista-card-info-botoes">
                                    <button class="botao-adicionar has-text-success is-clickable"
                                        @click="adicional.quantidade++, adicionaQtdAdicional(adicional)"
                                    >
                                        <i class="fas fa-plus"></i>
                                    </button>
                                    <input class="input-quantidade-adicional" disabled type="text" v-model="adicional.quantidade">
                                    <button class="botao-diminuir has-text-danger is-clickable"
                                        :disabled="adicional.quantidade==0"
                                        @click="adicional.quantidade--, removeQtdAdicional(adicional)"
                                    >
                                        <i class="fas fa-minus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </section>
        <detalhe-imagem-produto :visivel="exibeDetalheImagem"
            :scrImagem="produto.img"
            @esconderImagem="esconderImagem"
        >
        </detalhe-imagem-produto>
    </section>
</template>

<script>

import DetalheImagemProduto from './DetalheImagemProduto.vue';
import store from '@/store'


export default {
    name: 'DetalheProduto',
    components: {
        DetalheImagemProduto
    },
    data() {
        return {
            dados: {},
            produto: {},
            tamanhoSelecionado: { },
            massaSelecionada: { },
            bordaSelecionada: { },
            precoAdicional: 0,
            adicionais: [],
            caracteristicas: [],
            listaIdCaracteristicas: [],
            massas:[],
            bordas:[],
            exibeAdicionalPizza: false,
            exibeDetalheImagem: false,
            temCaracteristicaDiferenteAdicional: false,
            temCaracteristicaDiferenteMassa: false,
            temCaracteristicaDiferenteBorda: false,
        }
    },
    methods: {
        obterDados() {
            this.dados = store.state.dadosJson
        },
        obterProduto() {
            this.produto = this.$route.params.produto;
            if (!this.produto) {
                return this.$router.push('/produto')
            }
            if (this.produto.caracteristicas) {
              this.obterCaracteristicas(this.produto.caracteristicas)
            }
            if (this.produto.adicionais) {
                this.obterAdicionais(this.produto.adicionais)
            }
            if (this.ehProdutoPizza) {
              this.obterCaracteristicasPizza();
            }
        },
        obterAdicionais(listaAdicionais) {
            this.precoAdicional = 0;
            this.adicionais = (this.dados.adicionais.filter((adicional) => {
                return listaAdicionais.some((id) => {
                    return id === adicional.id
                })
            })).map((adicional) => {
                return {...adicional, quantidade: 0}
            })

            this.adicionais.forEach((adicional) => {
              if (adicional.caracteristicas && adicional.caracteristicas.length > 0) {
                let idsDiferentes = adicional.caracteristicas.filter(id => !this.listaIdCaracteristicas.includes(id)) 
                this.temCaracteristicaDiferenteAdicional = idsDiferentes.length > 0 ? true : false
              }
          })
        },

        obterCaracteristicas() {
          this.listaIdCaracteristicas = this.produto.caracteristicas ? [...this.produto.caracteristicas] : []
          if (this.ehProdutoPizza) {
            if (this.massaSelecionada.caracteristicas && this.massaSelecionada.caracteristicas.length > 0) {
              this.massaSelecionada.caracteristicas.forEach((caracteristica) => {
                if (!this.listaIdCaracteristicas.includes(caracteristica)) {
                  this.listaIdCaracteristicas.push(caracteristica);
                }
              })              
            }
            if (this.bordaSelecionada.caracteristicas && this.bordaSelecionada.caracteristicas.length > 0) {
              this.bordaSelecionada.caracteristicas.forEach((caracteristica) => {
                if (!this.listaIdCaracteristicas.includes(caracteristica)) {
                  this.listaIdCaracteristicas.push(caracteristica);
                }
              }) 
            }
          }

          this.adicionais.forEach((adicional) => {
            if (adicional.quantidade > 0) {
              if (adicional.caracteristicas && adicional.caracteristicas.length > 0) {
                adicional.caracteristicas.forEach((caracteristica) => {
                  if (!this.listaIdCaracteristicas.includes(caracteristica)) {
                    this.listaIdCaracteristicas.push(caracteristica);
                  }
                })
              }
            }
          })

          if (this.listaIdCaracteristicas.length) {
            this.caracteristicas = (this.dados.caracteristicas.filter((caracteristica) => {
              return this.listaIdCaracteristicas.some((id) => {
                return id === caracteristica.id
              })
            }))
          } else {
            this.caracteristicas = []
          }

        },

        buscarInfoPorTamanho(tamanho) {
            this.tamanhoSelecionado = tamanho
            this.massas = (this.dados.massas.filter((massa) => {
                return tamanho.massas.some((id) => {
                    return id === massa.id
                })
              })
            )
            if (tamanho.adicionais) {
                this.obterAdicionais(tamanho.adicionais)
            }

            this.massaSelecionada = {};
            this.bordas = {};            
            this.bordaSelecionada = {};
            this.precoAdicional = 0;
            this.exibeAdicionalPizza = this.massas.length > 0 ? false : true
        },

        buscarInfoPorMassa(massa) {
            this.massaSelecionada = massa
            this.bordas = (this.dados.bordas.filter((borda) => {
                return massa.bordas.some((id) => {
                    return id === borda.id
                })
            })
            )
            
            if (this.tamanhoSelecionado.adicionais) {
                this.obterAdicionais(this.tamanhoSelecionado.adicionais)
            }

            this.obterCaracteristicas();
            this.obterDadosBordas(this.massaSelecionada.bordas)

            this.bordaSelecionada = {};
            this.precoAdicional = 0;
            this.exibeAdicionalPizza = this.bordas.length > 0 ? false : true
        },

        buscarInfoPorBorda(borda) {
            this.bordaSelecionada = borda
            this.exibeAdicionalPizza = true
            if (this.temCaracteristicaDiferenteBorda) {
              this.obterCaracteristicas();
            }
        },

        adicionaQtdAdicional(adicional) {
            this.precoAdicional +=  Number(adicional.preco)
            if(adicional.caracteristicas && adicional.caracteristicas.length > 0) {
              this.obterCaracteristicas()
            }
        },

        removeQtdAdicional(adicional) {
            this.precoAdicional -=  Number(adicional.preco)
            if(adicional.caracteristicas && adicional.caracteristicas.length > 0) {
              this.obterCaracteristicas()
            }
        },

        voltarListaProduto() {
            this.$router.back()
        },
        
        abrirImagem() {
            this.exibeDetalheImagem = true;
        },

        esconderImagem() {
            this.exibeDetalheImagem = false;
        },

        limparDadosPizza() {
            this.tamanhoSelecionado = {};
        },

        obterIdsMassasPizza() {
          // if(this.produto.tamanhos.adicionais && this.produto.tamanhos.adicionais > 0) {
          //   this.verificarCaracteristicaAdicional(this.produto.tamanhos.adicionais)
          // }
          let idsMassasPizza = this.produto.tamanhos.reduce((massasTotais, tamanho) => {
            tamanho.massas.forEach(massa => {
                if (!massasTotais.includes(massa)) {
                    massasTotais.push(massa);
                }
            });
                return massasTotais;
          }, []);
          return idsMassasPizza
        },


        obterIdsBordasPizza(idMassasPizza) {
          let objMassasPizza = [];

          objMassasPizza = (this.dados.massas.filter((massa) => {
              return idMassasPizza.some((id) => {
                  return id === massa.id
              })
            })
          )

          objMassasPizza.forEach((massa) => {
            if(massa.adicionais && massa.adicionais.length > 0) {
              this.verificarCaracteristicaAdicional(massa.adicionais)
            }

            if (massa.caracteristicas && massa.caracteristicas.length > 0) {
              let idsDiferentes = massa.caracteristicas.filter(id => !this.listaIdCaracteristicas.includes(id)) 
              this.temCaracteristicaDiferenteMassa = idsDiferentes.length > 0 ? true : false
            }
          })

          let idsBordaPizza = objMassasPizza.reduce((bordasTotais, massas) => {
            massas.bordas.forEach(borda => {
                if (!bordasTotais.includes(borda)) {
                    bordasTotais.push(borda);
                }
            });
                return bordasTotais;
          }, []);
          return idsBordaPizza

        },

        obterDadosBordas(idsBordasPizza) {
          let objBordaPizza = [];

          objBordaPizza = (this.dados.bordas.filter((massa) => {
              return idsBordasPizza.some((id) => {
                  return id === massa.id
              })
            })
          )

          objBordaPizza.forEach((borda) => {
            if(borda.adicionais && borda.adicionais.length > 0) {
              this.verificarCaracteristicaAdicional(borda.adicionais)
            }
            if (borda.caracteristicas && borda.caracteristicas.length > 0) {
              let idsDiferentes = borda.caracteristicas.filter(id => !this.listaIdCaracteristicas.includes(id)) 
              this.temCaracteristicaDiferenteBorda = idsDiferentes.length > 0 ? true : false
            }
          })
        },

        verificarCaracteristicaAdicional(idsAdicionais) {
          this.adicionais = (this.dados.adicionais.filter((adicional) => {
              return idsAdicionais.some((id) => {
                  return id === adicional.id
              })
          }))

          this.adicionais.forEach((adicional) => {
            if (adicional.caracteristicas && adicional.caracteristicas.length > 0) {
              let idsDiferentes = adicional.caracteristicas.filter(id => !this.listaIdCaracteristicas.includes(id)) 
              if (idsDiferentes.length > 0) {
                this.temCaracteristicaDiferenteAdicional = true
              }
            }
          })
        },

        obterCaracteristicasPizza() {
          let idsMassasPizza = this.obterIdsMassasPizza()
          let idsBordasPizza = this.obterIdsBordasPizza(idsMassasPizza)
          this.obterDadosBordas(idsBordasPizza)

        }
    },
    computed: {
        ehProdutoPizza() {
            return this.produto.tpEspecialidade === "1"
        },

        valorMinimoPizza() {
            var menor = 99999;
            this.produto.tamanhos.forEach((item) => {
                menor = Number(item.preco) < menor ? item.preco : menor
            })
            return menor
        },

        valorMaximoPizza() {
            var maior = 0;
            this.produto.tamanhos.forEach((item) => {
                maior = Number(item.preco) > maior ? item.preco : maior
            })
            return maior
        },

        valorTotalPizza() {
            return Number(this.tamanhoSelecionado.preco || 0) + 
                   Number(this.massaSelecionada.preco || 0) + 
                   Number(this.bordaSelecionada.preco || 0) +
                   this.precoAdicional
        },

        valorTotalProduto() {
          return Number(this.produto.preco) + this.precoAdicional
        },

        exibeAlertaProduto() {
          return this.temCaracteristicaDiferenteAdicional || this.temCaracteristicaDiferenteMassa || this.temCaracteristicaDiferenteBorda
        },

        textoInfoCaracteristica() {
          let textoInfoCaracteristica = "Essas informações podem variar de acordo com a escolha "
          let textoPartes = []

          if (this.temCaracteristicaDiferenteAdicional) {
            textoPartes.push("do <b>adicional</b>") 
          }
          if (this.temCaracteristicaDiferenteMassa) {
            textoPartes.push("da <b>massa</b>") 
          }
          if (this.temCaracteristicaDiferenteBorda) {
            textoPartes.push("da <b>borda</b>") 
          }

          switch(textoPartes.length) {
            case 1:
              textoInfoCaracteristica += textoPartes[0]
              break;
            case 2:
              textoInfoCaracteristica += textoPartes.join(" ou ")
              break;
            case 3:
              textoInfoCaracteristica += textoPartes[0] + ", " + textoPartes[1] + " ou " + textoPartes[2]
              break;
          }

          return textoInfoCaracteristica
        }
    },
    mounted() {
        this.obterDados();
        this.obterProduto();
    }
}
</script>

<style lang="scss" scoped>
    .cardapio-digital-detalhe-produto {
        display: flex;
        flex-direction: column;
        align-items: center;

    }

    .cardapio-digital-detalhe-produto-section-imagem-container {
      background-image: linear-gradient(to bottom, #d4d4d4, #cfcfcf, #7e7e7e, #707070);
      position: relative;

      @media screen and (min-width: 481px) {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .cardapio-digital-detalhe-produto-section-btn-voltar {
        position: absolute;
        font-size: 25px;
        background-color: #DCDCDC;
        padding: 0.2rem;
        border-radius: 10px;
        left: 25px;
        top: 40px;

        @media screen and (max-width: 480px) {
          left: 25px;
          top: 40px;
        }
    }

    .cardapio-digital-detalhe-produto-section-btn-zoom {
        position: absolute;
        right: 20px;
        bottom: 40px;
        font-size: 20px;
        background-color: #DCDCDC;
        padding: 0.3rem;
        border-radius: 25px;
    }

    .cardapio-digital-detalhe-produto-section {
        display: flex;
        flex-direction: column;
        background-color: #EBE8E8;
        min-height: 100vh;
        max-width: 800px;
        width: 100%;
        @media screen and (max-width: 600px) {
            min-width: 100vw;
        }
    }

    .cardapio-digital-detalhe-produto-section-imagem {
      height: 300px;

      @media screen and (max-width: 480px) {
        width: 100%;
        object-fit: cover;
      }

      &:hover {
          cursor: pointer;
      }
    }   

    .cardapio-digital-detalhe-produto-section-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 1rem;
        padding-bottom: 3rem ;
        text-align: center;
        margin-top: -2.0rem;
        border-radius: 25px 25px 0px 0px;
        background-color: #EBE8E8;
        z-index: 1;
    }

    .cardapio-digital-detalhe-produto-section-lista-card-info-preco {
        font-size: 2.4rem;
        font-weight: bold;
        text-align: center;
    }

    .cardapio-digital-detalhe-produto-section-adicionais {
        border-top: 3px solid;
        padding: 1rem 0 1rem 0;
        width: 90vw;
        max-width: 800px;
    }

    .cardapio-digital-detalhe-produto-section-informacoes {
        border-top: 3px solid;
        padding: 1rem 0 1rem 0;
        width: 90vw;
        max-width: 800px;
    }

    .cardapio-digital-detalhe-produto-section-informacoes-alerta {
      padding: 5px 15px;
      border-radius: 10px;
    }

    .cardapio-digital-detalhe-produto-section-adicionais-lista {
        .cardapio-digital-detalhe-produto-section-adicionais-lista-card {
            background-color: #EBE8E8;
            padding: 0.6rem;
            border-radius: 1.25rem;
            border: 1px solid rgba(51, 51, 51, 0.2);
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            display: grid;
            grid-gap: 0.4rem;
            align-items: center;
            grid-template-columns: 1fr 1fr 1fr;
            margin-bottom: 1rem;
        }
    }

    .cardapio-digital-detalhe-produto-section-pizza {
        border-top: 3px solid;
        padding: 1rem 0 1rem 0;
        width: 90vw;
        max-width: 800px;
        transition: all 0.3s ease-in;
    }

    .cardapio-digital-detalhe-produto-section-pizza-lista-card {
        background-color: #EBE8E8;
        padding: 0.7rem;
        border-radius: 1.25rem;
        border: 1px solid rgba(51, 51, 51, 0.2);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 1rem;
        align-items: center;
        grid-template-columns: 1fr 1fr;
        margin-bottom: 1rem;

        &.card-adicional {
            grid-template-columns: 20% 40% 20% 20%;
            grid-gap: 0rem;
            padding: 0rem;
        }
    }

    .cardapio-digital-detalhe-produto-section-informacoes-lista {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;

      @media screen and (max-width: 600px) {
        justify-content: flex-start;
        flex-direction: column;
      }
    }

    .cardapio-digital-detalhe-produto-section-informacoes-lista-card-informacoes {
        background-color: #EBE8E8;
        padding: 0 0.7rem;
        border-radius: 1.25rem;
        display: grid;
        grid-template-columns: minmax(40px, 17%) 83%;
        grid-gap: 0.4rem;
        align-items: center;
        margin-bottom: 0.4rem;
    }

    .cardapio-digital-detalhe-produto-section-pizza-lista-card-img {
        margin: auto;
        width: 97px;
        height: 83px;
        margin: 0.7rem;
        border-radius: 5px;
    }

    .cardapio-digital-detalhe-produto-section-pizza-lista-card-info-descricao {
        font-size: 20px;
        text-align: center;
        font-weight: bold;
    }

    .cardapio-digital-detalhe-produto-section-informacoes-lista-card-descricao {
        font-size: 18px;
        text-align: left;
    }

    .cardapio-digital-detalhe-produto-section-informacoes-lista-card-info-descricao {
        font-size: 20px;
        text-align: left;
        font-weight: bold;
    }
        
    .cardapio-digital-detalhe-produto-section-pizza-lista-card-info-preco {
        font-size: 18px;
        font-weight: bold;
        text-align: center;
    }

    .cardapio-digital-detalhe-produto-section-pizza-lista-card-info-botoes {
        grid-template-rows: repeat(3, 1fr);
        width: 100%;
        height: 100%;

        >button {
            width: 100%;
            height: 30%;
            border: none;
            
            &.botao-adicionar {
                border-color: rgba(51, 51, 51, 0.2);
                border-radius: 0px 20px 0px 0px;
                border-left: 1px solid rgba(51, 51, 51, 0.2);
            }
            
            &.botao-diminuir {
                border-left: 1px solid rgba(51, 51, 51, 0.2);
                border-radius: 0px 0px 20px 0px;
            }

        }

        .input-quantidade-adicional {
            max-width: 100%;
            width: 100%;
            height: 40%;
            border: none;
            border-left: 1px solid rgba(51, 51, 51, 0.2);  
            font-weight: 600;
            font-size: 24px;
            display: flex;
            align-items: center;
            text-align: center;
        }
    }

    .cardSelecionado {
        border: 2px solid #23A076;
    }


</style>